import React from "react";
import { useTranslation } from "react-i18next";

import { Collapsible } from "@airhelp/react";
import { Divider, HStack, Image, Spacer, Heading, VStack } from "@chakra-ui/react";

import faqFormal from "assets/images/faq-formal@2x.png";
import { Card } from "elements";

export interface IFaq {
  id: string;
  question: string;
  answear: string;
}

interface IComponent {
  onToggle: (isToggle: boolean) => void;
}
const FAQs: React.FC<IComponent> = ({ onToggle }) => {
  const { t } = useTranslation();

  const FAQsList: IFaq[] = [
    {
      id: "use_with_a_fellow_passenger",
      question: t("lounges.faqs.use_with_a_fellow_passenger.question"),
      answear: t("lounges.faqs.use_with_a_fellow_passenger.answer"),
    },
    {
      id: "use_more_than_once",
      question: t("lounges.faqs.use_more_than_once.question"),
      answear: t("lounges.faqs.use_more_than_once.answer"),
    },
    {
      id: "dont_use_a_pass",
      question: t("lounges.faqs.dont_use_a_pass.question"),
      answear: t("lounges.faqs.dont_use_a_pass.answer"),
    },
    {
      id: "lounge_not_in_a_lounge_finder",
      question: t("lounges.faqs.lounge_not_in_a_lounge_finder.question"),
      answear: t("lounges.faqs.lounge_not_in_a_lounge_finder.answer"),
    },
  ];

  return (
    <Card
      maxWidth={{ base: "100%", lg: "785px" }}
      py={{ base: 1, md: 6 }}
      px={{ base: 5, md: 10 }}
      data-testid="lounges-faqs"
    >
      <HStack fontSize="md" fontWeight="medium" my={4}>
        <Heading variant="h5" mx={4}>
          {t("lounges.faqs.header")}
        </Heading>
        <Spacer />
        <Image src={faqFormal} height="48px" mr={4} display={{ base: "none", md: "block" }} />
      </HStack>
      <VStack mb={4} mt={{ base: 1, md: 0 }} spacing={0} alignItems="flex-start" w="100%">
        {FAQsList.map((item) => (
          <VStack
            key={`faqs-${item.id}`}
            w="100%"
            spacing={{ base: 0, md: 2 }}
            alignItems="flex-start"
            mx={{ base: -4, md: 0 }}
          >
            <Collapsible title={item.question} onToggle={onToggle}>
              {item.answear}
            </Collapsible>
            <Divider ml={4} w="calc(100% - 32px)" />
          </VStack>
        ))}
      </VStack>
    </Card>
  );
};

export default FAQs;
